export default {
  update: 'Update',
  edit: 'Edit',
  export_xls: 'Download tables',
  export_rda: 'Export to RD Cloud',
  duplicate: 'Duplicate',
  add_element: 'Add element',
  add_dashboard_element: 'Add dashboard element',
  add_to_dashboard: 'Add to dashboard',
  configuredElements: 'Configured elements',
  set_background: 'Set background',
  acknowledgeTheEvent: 'Acknowledge the event',
  delete: 'Delete',
  background_color: 'Background color',
  background_image: 'Background image',
  comment: 'Comment'
}
